import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { ArrowRight, EnvelopeOpen, XCircle } from '@phosphor-icons/react';
import { TokenType } from 'common/CommonConstants';
import Api from 'client/lib/Api';
import { trpc, useQuery } from 'client/lib/trpc';
import { Banner } from 'client/components/Banner';
import { Button } from 'client/components/Button';
import { DialogContent } from 'client/components/Dialog/DialogContent';
import { DialogContentSkeleton } from 'client/components/Dialog/DialogContentSekelton';
import { Modal } from 'client/components/Layout/Modal';
import { AccountInvite } from './invites/AccountInvite';
import { PilotInvite } from './invites/PilotInvite';

export const InvitePage: FC = () => {
  const { token } = useParams();

  const { data, isLoading } = useQuery(
    trpc.token.loadInvite,
    { token: token as string },
    {
      allowedStatuses: ['ok', 'invalid token', 'invalid account', 'invalid token type'],
      refetchOnWindowFocus: false,
    }
  );

  if (isLoading) {
    return (
      <Modal>
        <DialogContentSkeleton />
      </Modal>
    );
  }

  if (token && data?.status == 'ok' && data.type === TokenType.PILOT_INVITE) {
    return <PilotInvite token={token} />;
  }

  if (token && data?.status == 'ok' && data.type === TokenType.ACCOUNT_INVITE && data.account) {
    return <AccountInvite token={token} account={data.account} />;
  }

  return (
    <Modal>
      <DialogContent
        title="Invite Not Found"
        description="Invite is invalid or has expired"
        icon={<EnvelopeOpen />}
        iconOrnament={<XCircle />}
        actions={
          <Button icon={<ArrowRight weight="bold" />} href="/">
            Dashboard
          </Button>
        }
        dismissable={false}
      >
        <Banner type="error">
          Invite was not found. It might have been used, or expired. Please contact the person who sent the invite.
        </Banner>
      </DialogContent>
    </Modal>
  );
};
